// extracted by mini-css-extract-plugin
module.exports = {"addressCard":"AddressForm_addressCard__2HqZW","usePhysicalButton":"AddressForm_usePhysicalButton__2QcIo"};